var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.6665H22.0003",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.6665H4.66667",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H22",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H12",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33366 2C8.80633 2 10.0003 3.194 10.0003 4.66667C10.0003 6.13933 8.80633 7.33333 7.33366 7.33333C5.86099 7.33333 4.66699 6.13933 4.66699 4.66667C4.66699 3.194 5.86099 2 7.33366 2V2Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 19.3335H22.0003",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.3335H4.66667",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33366 16.6665C8.80633 16.6665 10.0003 17.8605 10.0003 19.3332C10.0003 20.8058 8.80633 21.9998 7.33366 21.9998C5.86099 21.9998 4.66699 20.8058 4.66699 19.3332C4.66699 17.8605 5.86099 16.6665 7.33366 16.6665V16.6665Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 9.3335C16.1393 9.3335 17.3333 10.5275 17.3333 12.0002C17.3333 13.4728 16.1393 14.6668 14.6667 14.6668C13.194 14.6668 12 13.4728 12 12.0002C12 10.5275 13.194 9.3335 14.6667 9.3335V9.3335Z",
    stroke: "#BBBBBB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4d4b1966c48e3909f188be96273a7a62.svg";
export { ForwardRef as ReactComponent };